import React from 'react';
import css from '../DetailsTab.scss';
import ContactInformation from '../ContactInformation';
import PropTypes from 'prop-types';
import Header from '../Header';
import { UserProfile } from 'utils/types';

/**
 * @param {object} props - see propTypes
 * @returns {JSX.Element} the Profile Details tab of the user's profile.
 */
function ProfileDetails(props) {
    return (
        <div className={css['header-block']}>
            <Header allowPhotoUpload={props.allowPhotoUpload}
                    firstName={props.originalProfile.firstName}
                    hasPhoto={props.profile.hasPhoto}
                    isIE={props.isIE}
                    lastName={props.originalProfile.lastName}
                    photoAcceptTypes={props.photoAcceptTypes}
                    pronouns={props.originalProfile.pronouns}
                    schoolEmail={props.originalProfile.schoolEmail}
                    showPronouns={props.showPronouns}
                    userName={props.originalProfile.userName}
                    uuid={props.profile.uuid}
                    validatePhoto={props.validatePhoto} />
            <div className={css['content-block']}>
                <ContactInformation allowEditPronouns={props.allowEditPronouns}
                                    allowPreferredEmail={props.allowPreferredEmail}
                                    cellPhone={props.profile.cellPhone}
                                    correspondenceTo={props.profile.correspondenceTo}
                                    goToNotificationsTab={props.goToNotificationsTab}
                                    isIE={props.isIE}
                                    mobileEmailInfoLink={props.mobileEmailInfoLink}
                                    phone={props.profile.phone}
                                    preferredEmail={props.profile.preferredEmail}
                                    pronouns={props.profile.pronouns}
                                    schoolEmail={props.profile.schoolEmail}
                                    // Since ContactInformation is a common component and staff state needs user details and notification preferences
                                    // under different objects, ContactInformation sets them separately in the state.
                                    // Student state does not need user details and notification preferences as separate objects, hence combining them under one
                                    setValue={({userProfile, notificationPreferences}) => props.setValue({...userProfile, ...notificationPreferences}) }
                                    showMobileEmailInfo={props.showMobileEmailInfo}
                                    showNotificationsLinks={props.showNotificationsLinks}
                                    showPronouns={props.showPronouns}
                                    supportedCountries={props.supportedCountries}
                                    textMessagingEnabled={props.textMessagingEnabled}
                                    textNotificationEnabledForUser={props.profile.textNotificationEnabled}
                                    timeZone={props.profile.timeZone}
                                    userName={props.profile.userName} 
                                    videoPhone={props.profile.videoPhone} />
            </div>
        </div>
    );
}

ProfileDetails.propTypes = {
    allowEditPronouns: PropTypes.bool,
    allowPhotoUpload: PropTypes.bool,
    allowPreferredEmail: PropTypes.bool,
    goToNotificationsTab: PropTypes.func,
    isIE: PropTypes.bool,
    mobileEmailInfoLink: PropTypes.string,
    originalProfile: UserProfile,
    photoAcceptTypes: PropTypes.string,
    profile: UserProfile,
    setValue: PropTypes.func.isRequired,
    showMobileEmailInfo: PropTypes.bool,
    showNotificationsLinks: PropTypes.bool,
    showPronouns: PropTypes.bool,
    supportedCountries: PropTypes.string,
    textMessagingEnabled: PropTypes.bool,
    validatePhoto: PropTypes.func.isRequired
};

export default ProfileDetails;
